<div class="app-music-toolbar">
  <div class="app-tab" (click)="musicService.activeMobilePanel = 'player'" [class.app-active]="musicService.activeMobilePanel == 'player'">
    <mat-icon>play_circle</mat-icon>
    <span class="app-desc">{{'music.toolbar.playing' | translate}}</span>
  </div>
  <div class="app-tab" (click)="musicService.activeMobilePanel = 'metadata'" [class.app-active]="musicService.activeMobilePanel == 'metadata'">
    <mat-icon>info</mat-icon>
    <span class="app-desc">{{'book_toolbar.desc_information' | translate}}</span>
  </div>
</div>